import React from "react";
import { Link } from "react-router-dom";

//BinaryForge Components
import { Field } from "../../";

//3rd Party Components
import { Button } from "primereact/button";

//Other
import { nav } from "../../../config/navigation";

//Demoted secondary detail - cloud id, alarm groups and events.
//Lives in a collapsed accordion section so it does not take prime real estate.
const DeviceDetailsMetaSection = ({ t, viewModel, onShowAlarmGroupDialog }) => {
	const { deviceId, deviceInfo } = viewModel.overview;

	return (
		<div className="grid columns-2 gapCol-large gapRow-medium aItems-start">
			<Field label={t("device.state.id")} response={deviceId} />
			<Field
				label="Alarm Groups"
				response={
					<div className="flex flexWrap" style={{ gap: "4px" }}>
						{deviceInfo.inputDevice?.length > 0 && (
							<Button
								className="p-link text-left"
								onClick={() => onShowAlarmGroupDialog("input")}
								label={t("device.state.alarmGroupsCount", {
									count: deviceInfo.alarmGroups.input.length,
									type: "input",
								})}
							/>
						)}
						{deviceInfo.outputDevice?.length > 0 && (
							<Button
								className="p-link text-left"
								onClick={() => onShowAlarmGroupDialog("output")}
								label={t("device.state.alarmGroupsCount", {
									count: deviceInfo.alarmGroups.output.length,
									type: "output",
								})}
							/>
						)}
					</div>
				}
			/>
			<Field
				label="Events"
				response={
					<div className="flex gapCol-xsmall">
						<Link to={`${nav.event.base}/${nav.event.management}?tab=live&device=${deviceInfo.name}`}>
							{deviceInfo.liveEventCount} Live
						</Link>
						<span>/</span>
						<Link to={`${nav.event.base}/${nav.event.management}?tab=archive&device=${deviceInfo.name}`}>
							{deviceInfo.archiveEventCount} Archive
						</Link>
					</div>
				}
			/>
		</div>
	);
};

export default DeviceDetailsMetaSection;
